import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { MeusVeiculosPageRoutingModule } from './meus-veiculos-routing.module';
import { MeusVeiculosPage } from './meus-veiculos.page';
import { MeusVeiculosEditPageModule } from '../meus-veiculos-edit/meus-veiculos-edit.module';
import { MeusVeiculosCreatePageModule } from '../meus-veiculos-create/meus-veiculos-create.module';
import { PipesModule } from 'src/app/pipes/pipes.module';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    PipesModule,
    MeusVeiculosPageRoutingModule,
    MeusVeiculosCreatePageModule,
    MeusVeiculosEditPageModule
  ],
  declarations: [MeusVeiculosPage]
})
export class MeusVeiculosPageModule {}
